import { render, staticRenderFns } from "./RealVideo.vue?vue&type=template&id=e1935378&scoped=true"
import script from "./RealVideo.vue?vue&type=script&lang=js"
export * from "./RealVideo.vue?vue&type=script&lang=js"
import style0 from "./RealVideo.vue?vue&type=style&index=0&id=e1935378&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1935378",
  null
  
)

export default component.exports